import * as R from 'ramda';

import {translate} from 'iss/strings';

/** Creates a validator out of a validation rule and a translation string pointing to the error tihs validation gives
 * The rule is a simple function from a value to whether it is valid according to this validator.
 **/
export function validatorFrom(rule, errorPath) {
  return {
    rule,
    getError: () => translate(errorPath)
  };
}

/** Takes a validator and returns another one with another error string */
export function withError(errorPath, validator) {
  return validatorFrom(validator.rule, errorPath);
}

function isInteger(value) {
  if (isNaN(value)) {
    return false;
  }
  const x = parseFloat(value);
  return (x | 0) === x;
}

function isNumber(value) {
  return !isNaN(parseFloat(value));
}

export function isHexColor(value) {
  return /^[0-9A-F]{6}$/i.test(value);
}

const notEmpty = R.compose(R.not,R.either(R.isEmpty, R.isNil));

export default {
  required : validatorFrom(notEmpty, "validation.shouldNotBeEmpty"),
  chooseOne: validatorFrom(notEmpty, "validation.chooseOne"),
  chooseAtLeastOne: validatorFrom(notEmpty, "validation.chooseAtLeastOne"),
  integer: validatorFrom(isInteger, "validation.shouldBeInteger"),
  number: validatorFrom(isNumber, "validation.shouldBeNumber"),
  hexColor: validatorFrom(isHexColor, "validation.shouldBeHexColor"),
  withError: withError,
};



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/form/validation/validators.js